"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PasteOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M22,6H20a2.006,2.006,0,0,0-2-2H16.82a2.988,2.988,0,0,0-5.64,0H10A2.006,2.006,0,0,0,8,6H6A2.006,2.006,0,0,0,4,8V28a2.006,2.006,0,0,0,2,2h4V28H6V8H8a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2h2v2h2V8A2.006,2.006,0,0,0,22,6ZM18,8H10V6h3V5a1,1,0,0,1,2,0V6h3Z"/><path d="M26,12H14a2.006,2.006,0,0,0-2,2V28a2.006,2.006,0,0,0,2,2H26a2.006,2.006,0,0,0,2-2V14A2.006,2.006,0,0,0,26,12Zm0,16H14V14H26Z"/><path d="M24,21a1,1,0,0,1-1,1H17a1,1,0,0,1,0-2h6A1,1,0,0,1,24,21Z"/><path d="M24,17a1,1,0,0,1-1,1H17a1,1,0,0,1,0-2h6A1,1,0,0,1,24,17Z"/>';
var PasteOutlineSVG = function PasteOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.PasteOutlineSVG = PasteOutlineSVG;
PasteOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PasteOutlineSVG);
exports.default = _default;